import * as runtime from '@/api/runtime'
import {
  BatchUserRemovalRequest,
  BatchUserRemovalRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchUserRemovalCondition,
  BatchUserRemovalConditionFromJSON
} from '@/api/models/batch/BatchUserRemovalCondition'

/**
 * 帳票作成
 */
export class BatchUserRemovalApi extends runtime.BaseAPI {
  async return(request: BatchUserRemovalRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/user-management/user-removal`,
      BatchUserRemovalRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchUserRemovalCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchUserRemovalConditionFromJSON(jsonValue)
    ).value()
  }
}
